import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const isDeltasharesItem = objectOf({
  app_group_id: string,
  sharing_id: string,
  tier: maybe(number, true),
});

export const isGetDeltasharesResult = objectOf({
  datashares: arrayOf(isDeltasharesItem),
  total_data_share_entitlements: number,
  used_non_tiered_entitlements: number,
  used_tier1_entitlements: number,
  used_tier2_entitlements: number,
  used_tier3_entitlements: number,
});

export const isMutateDeltasharesResult = objectOf({
  status: number,
  message: string,
  warn: maybe(string, true),
  warn_header: maybe(string, true),
});
